import { CheckSquare, CalendarDays, MessageSquare, Inbox, ShoppingCart, Star } from 'lucide-react'
import type { ComponentType } from 'react'
import type { Reminder, EntityLink, LinkedEntityType } from './types'

export function getEntityLinks(r: Reminder): EntityLink[] {
  if (r.payloadType !== 'entity_link' || !r.payload) return []
  const links = r.payload.links
  return Array.isArray(links) ? links : []
}

const ICONS: Record<LinkedEntityType, ComponentType<{ className?: string }>> = {
  task: CheckSquare,
  reservation: CalendarDays,
  conversation: MessageSquare,
  intent: Inbox,
  purchase: ShoppingCart,
  review: Star,
}

export function iconFor(type: LinkedEntityType): ComponentType<{ className?: string }> {
  return ICONS[type]
}

/** Canonical deep-link URL per entity type. Pages read these query params (wired in Task D4). */
export function deepLinkFor(link: EntityLink): string {
  switch (link.type) {
    case 'task':
      return `/tasks?taskId=${link.id}`
    case 'reservation':
      return `/reservations?reservationId=${link.id}`
    case 'conversation':
      return `/inbox?conversationId=${link.id}`
    case 'intent':
      // 统一 Intent 页（Intake console 已并入）；它同时认历史的 ?requestId=
      return `/intents?intentId=${link.id}`
    case 'purchase':
      return `/procurement?purchaseId=${link.id}`
    case 'review':
      return `/reviews/${link.id}`
    default:
      return '#'
  }
}
